import { getLocalTime } from '@qualle-admin/qutil/dist/date';
import { entries, groupBy } from 'lodash';

const alertThreshold = 5;

const state = {
  alerts: [],
};

const mutations = {
  LOAD_DATA(state, data) {
    state.alerts = data;
  },
};

const actions = {
  get_all_alerts: async ({ commit }, payload) => {
    try {
      const groupedTurnsByLocation = groupBy(
        payload,
        ({ location: { address } }) => address
      );
      const groupedLocations = entries(groupedTurnsByLocation).map(
        ([location, containers]) => ({
          containers: containers.filter(
            ({ status, turn_id: turnId }) => status === 'ready' && !turnId
          ),
          location,
          turns: containers.filter(({ turn_id: turnId }) => turnId),
        })
      );

      const filteredAlerts = groupedLocations
        .map(({ location, containers, turns }) => ({
          location,
          containers: containers.filter(({ lfd }) =>
            getLocalTime().isAfter(lfd, 'day')
          ),
          turns: turns.filter(({ lfd }) => getLocalTime().isAfter(lfd, 'day')),
        }))
        .filter(
          ({ containers, turns }) =>
            [...containers, ...turns].filter(({ lfd }) =>
              getLocalTime().isAfter(lfd, 'day')
            ).length > alertThreshold
        );

      const preparedAlerts = filteredAlerts.map(
        ({ location, containers, turns }) => ({
          location,
          error: true,
          alertType: 'Per Diem Risk Detected',
          message: `${
            [...containers, ...turns].length
          } containers past due at ${location}`,
        })
      );

      commit('LOAD_DATA', preparedAlerts);
    } catch (error) {
      commit('LOAD_DATA', []);
    }
  },
};

const getters = {
  get_alerts(state) {
    return state.alerts;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
